import { useContext } from "react";
import { ShellContext } from "../context";
import { ModuleManifest } from "../model";

/**
 * Gets the currently available set of module manifests.
 */
export function useModules(): ReadonlyArray<ModuleManifest> {
  const { modules } = useContext(ShellContext);
  return modules;
}
